import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { NgForm } from "@angular/forms";
import { Router } from '@angular/router';
import { UserService, User, Password } from './user.service';
import { CompanyService, Company } from './company.service';
import { MessageService } from '../common/message.service';
import { AppConstants, LOGON_INFO, USER_TYPE } from '../app.constants';
import $ from 'jquery';


@Component({
    selector: 'user',
    templateUrl: 'user.component.html',
    providers: [UserService, CompanyService]
})
export class UserComponent implements OnInit, OnDestroy {

    CONST: any = AppConstants;
    logon_comp_id: string = LOGON_INFO.COMP_ID;
    logon_comp_type: string = LOGON_INFO.COMP_TYPE;

    userList: User[];
    searchUserList: User[] = [];
    currentUser: User;
    companyList: Company[];
    pwd: Password;

    isLeaveUserPage: boolean;

    pageTitle: string = "ユーザー";

    currPage: number;
    totalCount: number;
    PAGE_SIZE: number = AppConstants.PAGE_SIZE;

    @ViewChild("f") f: NgForm;
    @ViewChild("f2") f2: NgForm;

    search_comp_id: string = "";

    constructor(
        public userService: UserService,
        public companyService: CompanyService,
        public messageService: MessageService,
        private router: Router
    ) {  }

    ngOnInit() {
        this.currPage = 1;
        this.isLeaveUserPage = this.router.url.indexOf('leave') > -1;
        this.companyList =  this.companyService.getCompanyListForCombo();

        this.refreshPage();
    }


    userUpdateModalShow(execDiv:string, user:User) {
        if (execDiv == this.CONST.REGIST) {
            this.clearSelectUser();
            $('#userUpdateModal .modal-title').text('【 '+this.pageTitle+'登録 】');
        } else {
            this.currentUser = Object.assign({},user);

            $('#userUpdateModal .modal-title').text('【 '+this.pageTitle+'修正 】');
        }

        $('#userUpdateModal').modal('show');
    }


    passwordUpdateModalShow() {
        this.clearPasswordInput();
        $('#passwordUpdateModal').modal('show');
    }


    checkUseridDuplicate(isValid: boolean) {
        if (isValid) {
            this.userService.checkUseridDuplicate(this.currentUser.userid)
            .subscribe(
                data => {
                    if (data['results'].length == 0) {
                        this.clearCustomError(this.f, "userid");
                    }
                    else {
                        this.setCustomError(this.f, "userid");
                    }
                }
            );
        }
    }


    //ユーザーリストを取得
    getUserList() {
        this.userService.getUserList(this.currPage, this.isLeaveUserPage)
            .subscribe(
                data => {
                    this.userList = data['results'];
                    this.totalCount = data['count'];
                    this.getUserSearchList();
                }
            );
    }


    //ドライバーリスト絞り込み
    getUserSearchList() {
        if (this.search_comp_id) {
            this.searchUserList = this.userList.filter((e:User) => e.comp_id == this.search_comp_id);
        } else {
            this.searchUserList = this.userList;
        }

        this.totalCount = this.searchUserList.length;
    }


    //ページ移動
    pageChange(page: number) {
        this.currPage = page;
        //this.getUserList();
        this.refreshPage();
    }


    checkPasswordEqual(isValid: boolean) {
        if (isValid) {
            if (this.pwd.password != this.pwd.passwordConfirm) {
                this.setCustomError(this.f2, "passwordConfirm");
            }
            else {
                this.clearCustomError(this.f2, "passwordConfirm");
            }
        }
    }


    //ユーザー登録
    registUser() {
        if (this.f.invalid) {
            return;
        }
        this.userService.registUser(this.currentUser)
            .subscribe(
                data => {
                    this.messageService.addInfo(this.pageTitle + "【" + this.currentUser.comp_name + "】が新規登録されました。")
                    //this.userList.push(data);
                    this.refreshPage();
                }
            );
    }

    //ユーザー更新
    updateUser() {
        this.userService.updateUser(this.currentUser)
            .subscribe(
                data => {
                    this.messageService.addInfo("【" + this.currentUser.comp_name + "】の情報が更新されました。");
                    this.refreshPage();
                }
            );
    }

    //ユーザー削除
    deleteUser() {
        this.userService.deleteUser(this.currentUser)
            .subscribe(
                data => {
                    // this.refreshPage();

                    this.userList.splice(this.userList.findIndex(({userid}) => userid === data.userid), 1);
                    this.totalCount--;
                    this.clearSelectUser();
                }
            );
    }

    //ユーザー復活
    reviveUser() {
        this.userService.updateUser(this.currentUser)
            .subscribe(
                data => {
                    // this.refreshPage();

                    this.userList.splice(this.userList.findIndex(({userid}) => userid === data.userid), 1);
                    this.totalCount--;
                    this.clearSelectUser();
                }
            );
    }


    updatePassword() {
        this.userService.updatePassword(this.pwd.passwordConfirm)
            .subscribe(
                data => {
                    this.clearPasswordInput();
                    this.messageService.addInfo("パスワードが変更されました。");
                }
            )
    }


    //画面リフレッシュ
    refreshPage(): void {
        this.clearSelectUser();
        this.clearPasswordInput();
        this.getUserList();
    }

    //入力欄クリア
    clearSelectUser(): void {
        this.currentUser = new User();
        this.currentUser.comp_id = "";
        this.currentUser.div = null;
        this.f.resetForm(this.currentUser);
        $('#userUpdateModal').modal('hide');
    }
    clearPasswordInput(): void {
        this.pwd = new Password();
        this.f2.resetForm(this.pwd);
        $('#passwordUpdateModal').modal('hide');
    }


    exec() {
        switch ($('#confirmModal_btn').text()) {
            case "登録":
                this.registUser();
                break;
            case "修正":
                this.updateUser();
                break;
            case "削除":
                this.deleteUser();
                break;
            case "復活":
                this.reviveUser();
                break;
        }
    }


    setCustomError(target_form: NgForm, control_name: string) {
        target_form.controls[control_name].setErrors({'custom':true});
        $('#'+control_name).addClass("is-invalid");
    }

    clearCustomError(target_form: NgForm, control_name: string) {
        target_form.controls[control_name].setErrors(null);
        $('#'+control_name).removeClass("is-invalid");
    }


    ngOnDestroy() {
        //Modalが開いた状態でブラウザの前ページへ移動ボタン押下すると、modalは閉じられるがbackdropが消えない
        //強制的にbackdropを消す
        $(".modal-backdrop").remove();
    }

}



// WEBPACK FOOTER //
// ./src/app/member-kanri/user.component.ts